
import React from 'react';
import { Brain, Shield, Users, Globe } from 'lucide-react';
import ValueCard from './ValueCard';

const ValuesSection = () => {
  const values = [
    {
      icon: Brain,
      title: 'Knowledge Accessibility',
      description: 'We believe AI knowledge should be accessible to everyone, regardless of technical background.',
      iconClassName: 'text-ai-blue',
      bgClassName: 'bg-blue-100'
    },
    {
      icon: Shield,
      title: 'Ethical Responsibility',
      description: 'We promote responsible AI development and usage that respects privacy and human rights.',
      iconClassName: 'text-ai-indigo',
      bgClassName: 'bg-indigo-100'
    },
    {
      icon: Users,
      title: 'Community Engagement',
      description: 'We foster an inclusive community where diverse perspectives contribute to AI discourse.',
      iconClassName: 'text-ai-purple',
      bgClassName: 'bg-purple-100'
    },
    {
      icon: Globe,
      title: 'Global Perspective',
      description: 'We consider the global implications of AI advancement across cultures and economies.',
      iconClassName: 'text-ai-cyan',
      bgClassName: 'bg-cyan-100'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">Our Values</h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            We're guided by core principles that shape everything we do at AI Nexus
          </p>
        </div>
        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {values.map((value, index) => (
            <ValueCard key={index} {...value} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
